<div class="inmate-card-row" (click)="viewInmateDetails(inmate)">
  <div class="inmate-card-cell inmate-image">
    <div class="inmate-image-container">
      <img [src]="mugshotImageDetails?.imageUrls?.size320 ?? 'assets/no-image-headshot.png'"
        alt="Mugshot"
        (error)="onImageError()" />
    </div>
  </div>
  <div class="inmate-card-cell inmate-name">
    <div class="main-data">{{ inmate.name.fullName }}</div>
    <div class="sub-data">ID: {{ inmate.soNumber }} </div>
  </div>
  <div class="inmate-card-cell inmate-arrest-date">
    <div class="main-data">{{ getMostRecentArrestDate() | date:'yyyy-MM-dd' }}</div>
    <div class="sub-data">{{ getMostRecentArrestDate() | date:'h:mm a' }}</div>
  </div>
  <div class="inmate-card-cell inmate-age">
    <div class="main-data">{{ inmate.age }}</div>
  </div>
  <div class="inmate-card-cell inmate-arresting-agency">
    <div class="main-data">{{ getMostRecentArrestingAgency() | na }}</div>
  </div>
  <div class="inmate-card-cell inmate-actions">
    <forge-icon-button aria-label="View Inmate Details" (click)="viewInmateDetails(inmate)">
      <forge-icon name="keyboard_arrow_right"></forge-icon>
    </forge-icon-button>
  </div>
</div>